import { combineReducers }          from 'redux';
import { router5Reducer }           from 'redux-router5';

// Reducers
import blogReducer                  from 'pursuit/store/reducers/blogReducer';
import environmentReducer           from 'pursuit/store/reducers/environmentReducer';
import { reducer as toastrReducer } from 'react-redux-toastr'

// Combine Reducers
var reducers = combineReducers({
    router:           router5Reducer,
    blogState:        blogReducer,
    environmentState: environmentReducer,
    toastr:           toastrReducer,
});

export default reducers;
